import { render } from "./upgradeButton.vue?vue&type=template&id=1d25f9d3&scoped=true"
import script from "./upgradeButton.vue?vue&type=script&lang=js"
export * from "./upgradeButton.vue?vue&type=script&lang=js"

import "./less/upgradeButton.less?vue&type=style&index=0&id=1d25f9d3&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d25f9d3"]])

export default __exports__